import React, { Component } from "react";
import Favicon from "react-favicon";
import queryString from "query-string";
import App from "../App";
import DiscontinuedPage from "../DiscontinuedPage";
import { ForbiddenScreen } from "../ErrorScreen";

class DataWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDiscontinued: false,

      selectedAccount: "mysegcause",

      CDDPresent: false,
      CDDUI: "",

      loading: true,

      forbidden: false,

      sessionInfo: {
        myhannafordcause: {
          account: "hf",
          gaID: "UA-142611659-1",
          bannersURL: "",
          statesURL: "HCStates",
          storesURL: "HCStores",
          accountUID: "779F5862-7EEB-4229-BA69-9BF7E42FE249",
          programUID: "B28671D3-1E1B-484D-9F18-04D29AC27B17",
          causeView: "[dbo].[PSIMVW_CDDSHccause]",
          addressTemplate: "${address}, ${city}",
          variableFields: {
            dateField: true,
            banners: false,
            states: true,
            stores: true,
          },
          removeSubmission: false,
        },
        mybigycause: {
          account: "bigy",
          gaID: "UA-135654479-1",
          bannersURL: "",
          statesURL: "BigYStates",
          storesURL: "BigYStores",
          accountUID: "f8deef48-5fc5-4e8c-802e-af512be3eb46",
          programUID: "635b525c-e223-4278-bdfe-93012a340a02",
          causeView: "[dbo].[PSIMVW_CDDSBYcause]",
          addressTemplate: "${address}, ${city}",
          variableFields: {
            dateField: true,
            banners: false,
            states: true,
            stores: true,
          },
        },
        mygmcause: {
          account: "gm",
          gaID: "UA-135641524-1",
          bannersURL: "GMBanners",
          statesURL: "",
          storesURL: "GMBannerStores",
          accountUID: "7181237a-a8d3-4878-8afa-3a74a0cd5acf",
          programUID: "023bc57c-4519-4bcb-b30e-e23296d05ac6",
          causeView: "[dbo].[PSIMVW_CDDSGMcause]",
          addressTemplate: "${state}, ${city}, ${address}",
          variableFields: {
            dateField: true,
            banners: true,
            states: false,
            stores: true,
          },
        },
        myhannafordb4gcause: {
          account: "hfb4g",
          gaID: "UA-142611659-1",
          bannersURL: "",
          statesURL: "HCStates",
          storesURL: "HCStores",
          accountUID: "779F5862-7EEB-4229-BA69-9BF7E42FE249",
          programUID: "B28671D3-1E1B-484D-9F18-04D29AC27B17",
          causeView: "[dbo].[PSIMVW_CDDSHHB4Gcause]",
          addressTemplate: "${address}, ${city}",
          variableFields: {
            dateField: true,
            banners: false,
            states: true,
            stores: true,
          },
          removeSubmission: false,
        },
      },
      pageContent: {
        myhannafordcause: {
          title: "Bloomin 4 Good",
          subTitle: "Bloomin’ 4 Good Plant Program",
          style: {
            primaryColor: "#e51419",
            secondaryColor: "",
            tertiaryColor: "",
            font: "",
          },
          contactInfo: {
            tagRedemptionURL: "https://myhannafordcause.bloomin4good.com",
            subsiteURL: "https://hannaford.bloomin4good.com/",
            programManager: "Jim Brennan",
            phone: "(603) 380-9339",
            email: "hannaford@bloomin4good.com",
          },
          introParagraphs: (
            <div className="intro-paragraphs">
              <p>
                Thank you for purchasing a Bloomin’ 4 Good Plant to support local hunger relief!
                Now you can select where to direct your $1 donation, resulting in 10+ meals* provided to those in need.
             </p>
               
              <p>
                Simply complete the following form and select the hunger relief organization you would like to support!
              </p>
              <p>
                If you have any questions, please contact us directly at{" "}
                <a href="mailto:hannaford@bloomin4good.com">
                  hannaford@bags4mycause.com
                </a>
                .
              </p>
            </div>
          ),
          privacy: (
            <p>
              All information provided will strictly adhere to Hannaford's{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.hannaford.com/customer-service/privacy"
              >
                Privacy Policy
              </a>
            </p>
          ),
          bottomStatement:
            "Hannaford Supermarkets has a long history of supporting the people and communities which we serve.  We appreciate the many nonprofits throughout these local communities that are working hard to keep them healthy.",
            feedingAmericaDisclosure:`*According to Feeding America, every $1 donation allows partners to secure and distribute at least 10 meals to those in need. To learn more, read this article by Feeding America: 
`,
            criteria: (
            <div className="requirements">
              <h3 style={{ color: "#e51419" }}>
                Nonprofit Criteria for the Program
              </h3>
              <p>
                The purpose of this program is to support the nonprofitin
                your community that are important to you. To be considered for a
                donation, organizations must have:
              </p>
              <ul>
                <li>501(c)(3) status.</li>
                <li>
                  A direct local connection to a specific Hannaford store.
                </li>
                <li>
                  Nonprofits that are clearly focused in their stated mission
                  to impact hunger relief
                </li>
              </ul>
              <p>
                Requests That Will <b>Not</b> Qualify:
              </p>
              <ul>
                <li>
                  Events/Fundraisers limited to specific individuals or families
                </li>
                <li>International Organizations</li>
                <li>
                  Any organization that does not have a clear hunger focus.
                </li>
                <li>
                  Any organization that does not put 100% of the donations to
                  supporting the local community
                </li>
                <li>
                  Requests to support expenses related to travel or conferences
                  for employees of nonprofitrganizations
                </li>
                <li>
                  Requests to support expenses related to fundraisers/events.
                </li>
                <li>Private clubs, such as rotary clubs</li>
                <li>
                  Any organization that discriminates on the basis of gender,
                  race, ethnicity, religion and/or sexual orientation
                </li>
              </ul>
            </div>
          ),
          tagDetails: {
            length: 6,
            mask: [
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
              "-",
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
            ],
            placeholder: "___-___",
          },
        },
        mybigycause: {
          title: "Bags 4 My Cause",
          subTitle: "Bloomin 4 Good Plant Program",
          style: {
            primaryColor: "#D22449",
          },
          contactInfo: {
            tagRedemptionURL: "https://mybigycause.bags4mycause.com",
            subsiteURL: "https://bigy.bags4mycause.com/",
            programManager: "Kim Monaco",
            phone: "(603) 380-9338",
            email: "bigy@bags4mycause.com",
          },
          introParagraphs: (
            <div className="intro-paragraphs">
              <p>
                With the Giving Tag, you can support the community you call home
                by directing your $1 donation generated from the purchase of the
                Community Bag to the Nonprofit of your choice.
              </p>
              <p>
                Just fill out the following form and you will be able to select
                the Nonprofit you would like to support!
              </p>
              <p>
                If you have any questions, please contact us directly at{" "}
                <a href="mailto:bigy@bags4mycause.com">bigy@bags4mycause.com</a>
                .
              </p>
            </div>
          ),
          privacy: (
            <p>
              All information provided will strictly adhere to Big Y's{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.bigy.com/Services/Policies/PrivacyPolicy"
              >
                Privacy Policy
              </a>
            </p>
          ),
          criteria: (
            <div className="requirements">
              <h3 style={{ color: "#D22449" }}>
                Nonprofit Criteria for the Program
              </h3>
              <p>
                The purpose of this program is to support the Nonprofits in
                your community that are important to you. To be considered for a
                donation, organizations must have:
              </p>
              <ul>
                <li>501(c)(3) status.</li>
                <li>A direct local connection to a specific Big Y store.</li>
                <li>
                  The commitment to put funds to use within the Big Y store’s
                  community.
                </li>
                <li>
                  Focus in their stated mission to impact hunger relief,
                  education (all aspects), health & wellness, civic, or
                  military/veterans organizations.
                </li>
              </ul>
              <p>
                Requests That Will <b>Not</b> Qualify:
              </p>
              <ul>
                <li>
                  Events/Fundraisers/Services that benefit a for-profit
                  business.
                </li>
                <li>
                  Events/Fundraisers limited to specific individuals or
                  families.
                </li>
                <li>Political organizations or lobbying groups.</li>
                <li>
                  Religious organizations (except where a food pantry is
                  involved).
                </li>
                <li>Private clubs.</li>
                <li>
                  Requests to support expenses related to fundraisers/events.
                </li>
                <li>
                  Any organization that discriminates on the basis of gender,
                  race, ethnicity, religion and/or sexual orientation.
                </li>
                <li>
                  Any organization that does not put 100% of the donations to
                  supporting the local community.
                </li>
              </ul>
            </div>
          ),
          bottomStatement:
            "Big Y is dedicated to supporting the communities we serve and the nonprofits that impact our customers. Thank you for joining us in these efforts!",
          tagDetails: {
            length: 6,
            mask: [
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
              "-",
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
            ],
            placeholder: "___-___",
          },
        },
        mygmcause: {
          title: "Bags 4 My Cause",
          subTitle: "Bloomin 4 Good Plant Program",
          style: {
            primaryColor: "#E5343D",
          },
          contactInfo: {
            tagRedemptionURL: "https://mygmcause.bags4mycause.com",
            subsiteURL: "https://giant.bags4mycause.com/",
            programManager: "Sarah Scott",
            phone: "(603) 380-9341",
            email: "giantmartins@bags4mycause.com",
          },
          introParagraphs: (
            <div className="intro-paragraphs">
              <p>
                With the Giving Tag, you can support the community you call home
                by directing your $1 donation generated from the purchase of the
                Bags 4 My Cause Bag to the nonprofit of your choice.
              </p>
              <p>
                Just fill out the following form and you will be able to select
                the nonprofit you would like to support!
              </p>
              <p>
                If you have any questions, please contact us directly at{" "}
                <a href="mailto:giantmartins@bags4mycause.com">
                  giantmartins@bags4mycause.com
                </a>
                .
              </p>
            </div>
          ),
          privacy: (
            <p>
              All information provided will strictly adhere to our{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://giantfoodstores.com/privacy-policy/"
              >
                Privacy Policy
              </a>
            </p>
          ),
          criteria: {
            "MARTIN'S": (
              <div className="requirements">
                <h3 style={{ color: "#E5343D" }}>
                  Nonprofit Criteria for the Program
                </h3>
                <p>
                  The purpose of this program is to support the nonprofits in
                  your community that are important to you. To be considered for
                  a donation, organizations must have:
                </p>
                <ul>
                  <li>501(c)(3) status.</li>
                  <li>A direct local connection to a MARTIN'S store.</li>
                  <li>
                    The commitment to put funds to use within the MARTIN's
                    store’s community.
                  </li>
                  <li>
                    Focus in their stated mission to impact hunger relief,
                    education (all aspects), health & wellness, civic, or
                    military/veterans organizations.
                  </li>
                </ul>
                <p>
                  Requests That Will <b>Not</b> Qualify:
                </p>
                <ul>
                  <li>
                    Events/Fundraisers/Services that benefit a for-profit
                    business.
                  </li>
                  <li>
                    Events/Fundraisers limited to specific individuals or
                    families.
                  </li>
                  <li>Political organizations or lobbying groups.</li>
                  <li>
                    Religious organizations (except where a food pantry is
                    involved).
                  </li>
                  <li>Private clubs.</li>
                  <li>
                    Requests to support expenses related to fundraisers/events.
                  </li>
                  <li>
                    Any organization that discriminates on the basis of gender,
                    race, ethnicity, religion and/or sexual orientation.
                  </li>
                  <li>
                    Any organization that does not put 100% of the donations to
                    supporting the local community.
                  </li>
                </ul>
              </div>
            ),
            GIANT: (
              <div className="requirements">
                <h3 style={{ color: "#E5343D" }}>
                  Nonprofit Criteria for the Program
                </h3>
                <p>
                  The purpose of this program is to support the nonprofits in
                  your community that are important to you. To be considered for
                  a donation, organizations must have:
                </p>
                <ul>
                  <li>501(c)(3) status.</li>
                  <li>A direct local connection to a GIANT store.</li>
                  <li>
                    The commitment to put funds to use within the GIANT store’s
                    community.
                  </li>
                  <li>
                    Focus in their stated mission to impact hunger relief,
                    education (all aspects), health & wellness, civic, or
                    military/veterans organizations.
                  </li>
                </ul>
                <p>
                  Requests That Will <b>Not</b> Qualify:
                </p>
                <ul>
                  <li>
                    Events/Fundraisers/Services that benefit a for-profit
                    business.
                  </li>
                  <li>
                    Events/Fundraisers limited to specific individuals or
                    families.
                  </li>
                  <li>Political organizations or lobbying groups.</li>
                  <li>
                    Religious organizations (except where a food pantry is
                    involved).
                  </li>
                  <li>Private clubs.</li>
                  <li>
                    Requests to support expenses related to fundraisers/events.
                  </li>
                  <li>
                    Any organization that discriminates on the basis of gender,
                    race, ethnicity, religion and/or sexual orientation.
                  </li>
                  <li>
                    Any organization that does not put 100% of the donations to
                    supporting the local community.
                  </li>
                </ul>
              </div>
            ),
          },
          bottomStatement:
            "We are dedicated to supporting the communities we serve and the nonprofits that impact our customers. Thank you for joining us in these efforts!",
          tagDetails: {
            length: 6,
            mask: [
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
              "-",
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
            ],
            placeholder: "___-___",
          },
        },

        mysegcause: {
          title: "Bags 4 My Cause",
          subTitle: "Bloomin 4 Good Plant Program",
          style: {
            primaryColor: "#2B658F",
          },
          contactInfo: {
            tagRedemptionURL: "https://mysegcause.bags4mycause.com",
            subsiteURL: "https://seg.bags4mycause.com/",
            programManager: "Kim Monaco",
            phone: "(603) 380-9337",
            email: "seg@bags4mycause.com",
          },
          introParagraphs: (
            <div className="intro-paragraphs">
              <p>
                With the Giving Tag, you can support the community you call home
                by directing your $1 donation generated from the purchase of the
                Community Bag to the nonprofitof your choice.
              </p>
              <p>
                Just fill out the following form and you will be able to select
                the nonprofityou would like to support!
              </p>
              <p>
                If you have any questions, please contact us directly at{" "}
                <a href="mailto:seg@bags4mycause.com">seg@bags4mycause.com</a>.
              </p>
            </div>
          ),
          privacy: (
            <p>
              All information provided will strictly adhere to our{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.segrocers.com/privacypolicy"
              >
                Privacy Policy
              </a>
            </p>
          ),
          criteria: (
            <div className="requirements">
              <h3 style={{ color: "#2B658F" }}>
                NonprofitCriteria for the Program
              </h3>
              <p>
                The purpose of this program is to support the nonprofit in
                your community that are important to you. To be considered for a
                donation, organizations must have:
              </p>
              <ul>
                <li>501(c)(3) status.</li>
                <li>
                  A direct local connection to a specific BI-LO, Fresco y Más,
                  Harveys or Winn-Dixie store.
                </li>
                <li>
                  The commitment to put funds to use within the local BI-LO,
                  Fresco y Más, Harveys or Winn-Dixie store’s community.
                </li>
                <li>
                  Focus in their stated mission to impact hunger relief,
                  education (all aspects), health & wellness, civic, disaster
                  relief, or military/veterans organizations.
                </li>
              </ul>
              <p>
                Requests That Will <b>Not</b> Qualify:
              </p>
              <ul>
                <li>
                  Events/Fundraisers/Services that benefit a for-profit
                  business.
                </li>
                <li>
                  Events/Fundraisers limited to specific individuals or
                  families.
                </li>
                <li>Political organizations or lobbying groups.</li>
                <li>Private clubs.</li>
                <li>
                  Requests to support expenses related to fundraisers/events.
                </li>
                <li>
                  Any organization that discriminates on the basis of gender,
                  race, ethnicity, religion and/or sexual orientation.
                </li>
                <li>
                  Any organization that does not put 100% of the donations to
                  supporting the local community.
                </li>
              </ul>
            </div>
          ),
          bottomStatement:
            "We are dedicated to supporting the communities we serve and the nonprofits that impact our customers. Thank you for joining us in these efforts!",
          tagDetails: {
            length: 6,
            mask: [
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
              "-",
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
            ],
            placeholder: "___-___",
          },
        },
        myhannafordb4gcause: {
          title: "Bloomin 4 Good",
          subTitle: "Bloomin’ 4 Good Plant Program",
          style: {
            primaryColor: "#e51419",
            secondaryColor: "",
            tertiaryColor: "",
            font: "",
          },
          contactInfo: {
            tagRedemptionURL: "https://myhannafordcause.bags4mycause.com",
            subsiteURL: "https://hannaford.bags4mycause.com/",
            programManager: "Jim Brennan",
            phone: "(603) 380-9339",
            email: "hannaford@bags4mycause.com",
          },
          introParagraphs: (
            <div className="intro-paragraphs">
              <p>
                Thank you for purchasing a Bloomin’ 4 Good Plant to support local hunger relief!
                Now you can select where to direct your $1 donation, resulting in 10+ meals* provided to those in need.
              </p>
              <p>
                Simply complete the following form and select the hunger relief organization you would like to support!
              </p>
              <p>
                If you have any questions, please contact us directly at{" "}
                <a href="mailto:hannaford@bags4mycause.com">
                  hannaford@bags4mycause.com
                </a>
                .
              </p>
            </div>
          ),
          privacy: (
            <p>
              All information provided will strictly adhere to Hannaford's{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.hannaford.com/customer-service/privacy"
              >
                Privacy Policy
              </a>
            </p>
          ),
          bottomStatement:
            "Hannaford Supermarkets has a long history of supporting the people and communities which we serve.  We appreciate the many nonprofits throughout these local communities that are working hard to keep them healthy.",
          criteria: (
            <div className="requirements">
              <h3 style={{ color: "#e51419" }}>
                Nonprofit Criteria for the Program
              </h3>
              <p>
                The purpose of this program is to support the nonprofits in
                your community that are important to you. To be considered for a
                donation, organizations must have:
              </p>
              <ul>
                <li>501(c)(3) status.</li>
                <li>
                  A direct local connection to a specific Hannaford store.
                </li>
                <li>
                  Nonprofits that are clearly focused in their stated mission
                  to impact hunger relief, education (all aspects), health &
                  wellness, civic, or military/veterans organizations
                </li>
                <li>
                  Organizations that provide for the physical, emotional,
                  educational and cultural enhancement and well-being of
                  children
                </li>
              </ul>
              <p>
                Requests That Will <b>Not</b> Qualify:
              </p>
              <ul>
                <li>
                  Events/Fundraisers limited to specific individuals or families
                </li>
                <li>International Organizations</li>
                <li>
                  Any organization that does not put 100% of the donations to
                  supporting the local community
                </li>
                <li>
                  Requests to support expenses related to travel or conferences
                  for employees of nonprofit organizations
                </li>
                <li>
                  Requests to support expenses related to fundraisers/events.
                </li>
                <li>Private clubs, such as rotary clubs</li>
                <li>
                  Any organization that discriminates on the basis of gender,
                  race, ethnicity, religion and/or sexual orientation
                </li>
              </ul>
            </div>
          ),
          tagDetails: {
            length: 6,
            mask: [
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
              "-",
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
              /[A-Za-z0-9]/,
            ],
            placeholder: "___-___",
          },
        },
      },
    };
  }

  componentDidMount() {
    const { sessionInfo } = this.state;

    const hostnameArr = window.location.hostname.split(".");

    const params = queryString.parse(window.location.search);


    // myhannafordb4gcause
    // if(params["myhannafordb4gcause"]){
    //   console.log('params:', params, "subdomain",subdomain, hostnameArr[0]?.toLowerCase() )
    //   this.setState({ forbidden: false });
    //   return;
    // }

    if (window.location.hostname.includes("mytestcause")) {
      if (!(params.code && params.code === "68310824")) {
        this.setState({ forbidden: true });
        return;
      }
    }

    if ("CDDUI" in params) {
      this.setState({
        CDDUI: params.CDDUI,
        CDDPresent: true,
      });
    }

    const subdomain = hostnameArr[0].toLowerCase();

    const accountList = Object.keys(sessionInfo);
    console.log('accountList:', accountList, "subdomain", subdomain, hostnameArr[0]?.toLowerCase())
    let account = "";

    if (hostnameArr[0]?.toLowerCase() === "bookwellfeeds") {
      account = "bookwellfeeds";
    } else if (accountList.includes(subdomain)) {
      account = subdomain;
    } else if ("test" in params) {
      accountList.forEach((acc) => {
        console.log(acc);
        console.log(sessionInfo[acc].account);
        if (sessionInfo[acc].account === params.test.toLowerCase()) {
          account = acc;
        }
      });
    } else {
      console.log("forbidden because of subdomain", subdomain);
      this.setState({ forbidden: true });
      return;
    }

    const discontinuedAccounts = ["mygmcause"];

    if (discontinuedAccounts.includes(account)) {
      this.setState({ isDiscontinued: true });
    }

    console.log(account);

    this.setState((prevState) => ({
      loading: false,
      selectedAccount: account,
      faviconURL: `${process.env.PUBLIC_URL}images/${prevState.sessionInfo[account].account}/favicons/favicon.ico`,
    }));
  }

  cancelCDD = () => {
    this.setState({
      CDDUI: "",
      CDDPresent: false,
    });
  };

  render() {
    const {
      forbidden,
      selectedAccount,
      loading,
      faviconURL,
      CDDUI,
      CDDPresent,
      sessionInfo,
      pageContent,
    } = this.state;

    if (forbidden) {
      return <ForbiddenScreen />;
    }

    if (this.state.isDiscontinued) {
      return (
        <div>
          <Favicon url={faviconURL} />
          <DiscontinuedPage
            CDDUI={CDDUI}
            CDDPresent={CDDPresent}
            selectedAccount={selectedAccount}
            sessionInfo={sessionInfo[selectedAccount]}
            pageContent={pageContent[selectedAccount]}
            cancelCDD={this.cancelCDD}
          />
        </div>
      );
    }

    if (selectedAccount && !loading) {
      return (
        <div>
          <Favicon url={faviconURL} />
          <App
            CDDUI={CDDUI}
            CDDPresent={CDDPresent}
            selectedAccount={selectedAccount}
            sessionInfo={sessionInfo[selectedAccount]}
            pageContent={pageContent[selectedAccount]}
            cancelCDD={this.cancelCDD}
          />
        </div>
      );
    }
    return <div />;
  }
}

export default DataWrapper;
